import React from "react";
import "../../../css/Common/Components/DesignSystem/AdviserValues.css"; // Include your custom styles

/**
 * AdviserValues component renders a grid of adviser values with optional children content.
 *
 * @param {Object} props - The component props.
 * @param {Array<{icon: React.ReactNode, text: string}>} props.values - Array of value objects, each containing an icon and text to display.
 * @param {boolean} [props.isAdviser=false] - Flag to apply adviser-specific styling.
 * @param {string} props.title - The title to display above the values grid.
 * @param {React.ReactNode} [props.children=null] - Optional children to render below the values grid.
 * @returns {JSX.Element} The rendered AdviserValues component.
 */
const AdviserValues = ({
  values,
  isAdviser = false,
  title,
  children = null,
}) => {
  return (
    <div className={`Adviser-Values-Container ${isAdviser ? "Adviser " : ""}`}>
      <h2>{title}</h2>
      <div className="Adviser-Value-Grid">
        {values.map((value, index) => (
          <div className="Adviser-Value" key={index}>
            {value.icon}
            <div className="SubTitle-SemiBold">{value.text}</div>
          </div>
        ))}
      </div>
      {
        // Render children if any
        children && <div style={{
        
        }}>{children}</div>
      }
      {/* <div>{children}</div> */}
    </div>
  );
};

export default AdviserValues;
